import { useMutation, useQueryClient } from '@tanstack/react-query';

import { OrganisationResponse, UpdateOrganizationRequest, IUpdateOrganizationRequest } from '@joc/api-gateway';

import { ORGANIZATIONS_QUERY_KEY } from 'core/constants';

import { API } from 'core/API';

interface IUseUpdateOrganization {
	// eslint-disable-next-line no-unused-vars
	updateOrganization: ({ id, values }: { id: number; values: IUpdateOrganizationRequest }) => void;
	isSuccess: boolean;
	isPending: boolean;
	isError: boolean;
	error: Error | null;
}

const updateOrganizationApi = async (id: number, values: IUpdateOrganizationRequest) => {
	const requestBody = UpdateOrganizationRequest.fromJS(values);

	return API.updateOrganisation(id, undefined, requestBody);
};

export const useUpdateOrganization = (): IUseUpdateOrganization => {
	const queryClient = useQueryClient();
	const {
		mutate: updateOrganization,
		isSuccess,
		isPending,
		isError,
		error,
	} = useMutation<OrganisationResponse, Error, { id: number; values: IUpdateOrganizationRequest }>({
		mutationFn: ({ id, values }) => updateOrganizationApi(id, values),
		onSettled: () => queryClient.invalidateQueries({ queryKey: [ORGANIZATIONS_QUERY_KEY] }),
	});

	return { updateOrganization, isSuccess, isPending, isError, error };
};
